import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar } from '../common/Navbar.jsx';
import { Footer } from '../common/Footer.jsx';
import { SupportChatWidget } from '../support/SupportChatWidget.jsx';

export function MainLayout() {
  return (
    <div className="app-shell" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Navbar />
      <main style={{ flex: 1 }}>
        <Outlet />
      </main>
      <Footer />
      <SupportChatWidget />
    </div>
  );
}
